import ExecutableCodeBlock from 'react-scale/components/scalers/tasks/ThreadedInteraction/coding/ExecutableCodeBlock';
import { Tabs } from '@scale/scaleui';
import { useState, useEffect, useMemo } from 'react';

interface Props {
  options: {
    id: string;
    label: string;
    value: string;
  }[];
  defaultTab: string;
  language: 'json';
}

const ToolUseTabbedCodeBlock: React.FC<Props> = ({ options, defaultTab, language }) => {
  const [tab, setTab] = useState<string>(defaultTab);

  useEffect(() => {
    setTab(defaultTab);
  }, [defaultTab]);

  const activeOption = useMemo(() => {
    const option = options.find(option => option.id === tab);
    if (!option) {
      return options[0];
    }
    return option;
  }, [options, tab]);

  return (
    <div className="flex flex-col gap-4 w-full">
      <Tabs tabs={options} value={tab} onChange={tabId => setTab(tabId)} variant="default" />
      <ExecutableCodeBlock
        code={activeOption.value}
        codeBlocksInMarkdownText={[]}
        // @ts-ignore
        languageMatch={[language, language]}
        codeBlockIndex={0}
        loading={false}
        defaultExpanded={false}
      />
    </div>
  );
};

export default ToolUseTabbedCodeBlock;
